<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<slice-flex-close
  *ngIf="canBeClosed"
  [settings]="slice.settings"
  (click)="deleteSlice()">
</slice-flex-close>

<ng-container *ngFor="let slot of slots; let i = index; trackBy: trackByIndex">
  <render-slice-slot
    data-e2e="render-slice-slot"
    class="slot"
    [slice]="slice"
    [slot]="(i + 1).toString()"
    *ngIf="!slot.hidden"
    [ngStyle]="getSlotStyles(slot)"
    [attr.aria-hidden]="slice?.settings.general?.accessibility?.accessibilityHidden ? 'true' : 'false'"
    [attr.role]="slice?.settings.general?.accessibility?.accessibilityRegion ? 'region' : null"
    [attr.aria-label]="slice?.settings?.general?.accessibility?.accessibilityLabel || null"
    >
  </render-slice-slot>
</ng-container>

<img
  #image
  *ngIf="hasCustomCursorIcon"
  alt="custom-cursor-icon"
  class="cursor-image"
  [src]="customCursorIcon"
  [attr.width]="slice?.settings?.general?.customCursor?.width"
  [attr.height]="slice?.settings?.general?.customCursor?.height"/>
